<template>
  
  <div class="course-card">
    <figure class="course-card__image">
      <router-link :to='`/mycourse/${course.id}/video`' @click="$bus.emit('loading-toggle')" v-if="this.mycourse">
        <img :src="course.thumbnail" v-if="course.thumbnail" />
        <img src="https://fakeimg.pl/350x200/?text=Sajilo Class" v-else  />
      </router-link>
      <router-link :to='`/course/${course.id}/detail`' @click="$bus.emit('loading-toggle')" v-else>
        <img :src="course.thumbnail" v-if="course.thumbnail" />
        <img src="https://fakeimg.pl/350x200/?text=Sajilo Class" v-else  />
      </router-link>
    </figure>
    <div class="course-card__body">
      <div class="course-card__price" v-if="course.package[0] && course.has_bought === false">
        <!-- <span v-if="course.package[0].discounted_price">Rs {{ course.package[0].discounted_price.substring(3, '') }}</span> -->
        <span >Rs {{ course.package[0].discounted_price.substring(3, '') }}</span>
      </div>

      <span class="course-card__date">{{ course.datetime_created | truncate(10, "") }}</span>
      <a href="#!" class="course-card__instructor-name">{{
        course.lecturer.full_name
      }}</a>

      <h3 class="course-card__title">
        <router-link :to='`/course/${course.id}/detail`' @click="$bus.emit('loading-toggle')">{{ course.title | truncate(48, "...") }}</router-link>
      </h3>

      <span class="course-card__purchasecounter" v-if="course.has_bought === false">
        {{ course.lectures_count }} purchases
      </span>

      <div class="d-flex align-center justify-between" v-if="course.has_bought === true">
        <div class="course-card__progress">
          <v-progress-linear
            rounded
            color="red darken-2"
            :value="Math.trunc(course.complete_percentage)"
          ></v-progress-linear>
        </div>

        <span class="course-card__purchasecounter"> {{course.complete_percentage ? Math.trunc(course.complete_percentage) : '0'}}% complete </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseCard",

  props: {
    course: {
      type: Object,
      required: true,
    },
    mycourse: {
      type: Boolean,
    }
  },
  data() {
    return {
      user: null,
    };
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>